import $ from 'jquery';
import Cache from 'root/cache';
import View from 'view/base';

export default View.extend({
    className: 'project-settings-menu',

    menu: 'general',

    events: {
        'click .tab-menu > a': 'onClickMenu'
    },

    dom_handlers: {
        onClickMenu: function(e) {
            var menu_name = $(e.currentTarget).attr('href').replace('#', '');

            this.trigger('navigate', menu_name);
        }
    },

    initialize: function(options) {
        this.menu = options && options.menu ? options.menu : 'general';
    },

    render: function() {
        var content =
        '<div class="tab">' +
            '<div class="tab-menu">' +
                '<a href="#general">' +
                    '<span class="text">General</span>' +
                '</a>' +
                (this.model.isFeedback() ?
                '<a href="#workflow">' +
                    '<span class="text">Workflow</span>' +
                '</a>' +
                '<a href="#automation">' +
                    '<span class="text">Automation</span>' +
                '</a>' : '') +

                (this.model.isFeedback() && !Cache.account.get('appsumo') ?
                '<a href="#email_forwarding">' +
                    '<span class="text">Email Forwarding</span>' +
                '</a>' : '') +

                (this.model.isFeedback() ?
                '<a href="#ai_assist">' +
                    '<span class="text">AI Assist</span>' +
                '</a>' : '') +

                (this.model.isFeedback() ?
                '<a href="#privacy">' +
                    '<span class="text">Privacy</span>' +
                '</a>' : '') +

                (this.model.isFeedback() ?
                '<a href="#advanced">' +
                    '<span class="text">Advanced</span>' +
                '</a>' : '') +
            '</div>' +
        '</div>';

        this.$el.html(content);

        this.$el.find('.tab-menu a[href="#' + this.menu + '"]').addClass('active');

        return this;
    }
});